import { cn } from '@/lib/utils';
import React from 'react';

interface MenuProps extends React.HTMLAttributes<HTMLDivElement> {}
interface MenuItemProps extends React.HTMLAttributes<HTMLDivElement> {
  inset?: boolean;
}

const MenuItem = React.forwardRef<HTMLDivElement, MenuItemProps>(
  ({ className, inset, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        inset && 'pl-8',
        className
      )}
      {...props}
    />
  )
);
MenuItem.displayName = 'MenuItem';

const Menu = React.forwardRef<HTMLDivElement, MenuProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex h-full w-full flex-col overflow-hidden rounded-md bg-popover p-1 text-popover-foreground',
        className
      )}
      {...props}
    />
  )
);
Menu.displayName = 'Menu';

const MenuSeparator = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('my-1 h-px bg-border', className)} {...props} />
));
MenuSeparator.displayName = 'MenuSeparator';

export { Menu, MenuItem, MenuSeparator };
